import React from 'react';
import { SpanBadge } from './style';

interface BlockRelevanceBadgeProps {
  relevance: number;
}

const BlockRelevanceBadge = (props: BlockRelevanceBadgeProps) => {
  const { relevance } = props;

  const getTaskClass = (relevance: number) => {
    if (relevance < 0.25) return 'orange';
    if (relevance >= 0.25 && relevance < 0.5) return 'warning';
    if (relevance >= 0.5) return 'success';

    return 'info';
  };

  const getTaskLabel = (relevance: number) => {
    if (relevance < 0.25) return 'Baixa';
    if (relevance >= 0.25 && relevance < 0.5) return 'Média';
    if (relevance >= 0.5 && relevance < 0.75) return 'Alta';
    if (relevance >= 0.75) return 'Muito Alta';
    return 'Futura';
  };

  return (
    <SpanBadge className={`badge badge-pill badge-${getTaskClass(relevance)} px-2 py-1`}>
      {getTaskLabel(relevance)}
    </SpanBadge>
  );
};

export default BlockRelevanceBadge;
